/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
  const wrapper = document.querySelector('[data-products-grid]');
  const productItems = document.querySelectorAll('.product-item .product-item__swatch');
  const siblingItems = document.querySelectorAll('.product-item product-siblings [data-scrollbar]');

  const mobileQuickSizeSheetMq = window.matchMedia('(max-width: 749px)');
  const desktopQuickSizeMq = window.matchMedia('(min-width: 750px)');

  function getQuickSizeMobileSheetMount(root) {
    return root._mobileSheetMount || root.querySelector('[data-quick-size-mobile-sheet]');
  }

  function getQuickSizeRootFromSheetMount(sheetMount) {
    return sheetMount?._quickSizeRoot || null;
  }

  function getQuickSizeProductSlider(root) {
    const gridItem = root.closest('[data-grid-item]');
    if (!gridItem) return null;
    return gridItem.closest('[data-grid-slider]');
  }

  function preserveSliderScrollPosition(root) {
    const slider = getQuickSizeProductSlider(root);
    if (!slider) return;
    root._sliderScrollLeft = slider.scrollLeft;
  }

  function restoreSliderScrollPosition(root) {
    const slider = getQuickSizeProductSlider(root);
    if (!slider || root._sliderScrollLeft == null) return;
    slider.scrollLeft = root._sliderScrollLeft;
  }

  function clearSliderScrollPosition(root) {
    delete root._sliderScrollLeft;
  }

  function portalQuickSizeMobileSheet(root, sheetMount) {
    if (!mobileQuickSizeSheetMq.matches || !sheetMount || sheetMount.dataset.quickSizePortaled === 'true') return;

    root._mobileSheetMount = sheetMount;
    sheetMount._quickSizeRoot = root;
    sheetMount._portalParent = sheetMount.parentElement;
    sheetMount._portalNextSibling = sheetMount.nextSibling;
    document.body.appendChild(sheetMount);
    sheetMount.dataset.quickSizePortaled = 'true';
  }

  function restoreQuickSizeMobileSheet(root) {
    const sheetMount = getQuickSizeMobileSheetMount(root);
    if (!sheetMount || sheetMount.dataset.quickSizePortaled !== 'true') return;

    const parent = sheetMount._portalParent;
    const nextSibling = sheetMount._portalNextSibling;

    if (parent) {
      if (nextSibling && nextSibling.parentNode === parent) {
        parent.insertBefore(sheetMount, nextSibling);
      } else {
        parent.appendChild(sheetMount);
      }
    }

    delete sheetMount.dataset.quickSizePortaled;
    delete sheetMount._quickSizeRoot;
    delete sheetMount._portalParent;
    delete sheetMount._portalNextSibling;
    root._mobileSheetMount = sheetMount;
  }

  function closeQuickSizeMobileSheet(root) {
    if (!root || !root.classList.contains('is-mobile-sheet-open')) return;
    const sheetMount = getQuickSizeMobileSheetMount(root);
    const toggle = root.querySelector('.quick-size-option__toggle');
    const sheet = sheetMount?.querySelector('.quick-size-option__sheet');
    if (!sheetMount) return;

    sheetMount.classList.remove('is-open');
    sheetMount.setAttribute('hidden', '');
    sheetMount.setAttribute('inert', '');
    sheetMount.setAttribute('aria-hidden', 'true');
    root.classList.remove('is-mobile-sheet-open');

    const imgHolder = root.closest('[data-product-image]');
    if (imgHolder) imgHolder.classList.remove('quick-size-sheet-active');

    if (toggle) toggle.setAttribute('aria-expanded', 'false');

    sheet?.querySelectorAll('.quick-size-option__sheet-body .size-item.is-selected').forEach((el) => {
      el.classList.remove('is-selected');
    });

    restoreQuickSizeMobileSheet(root);
    clearSliderScrollPosition(root);

    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true, detail: 0 }));

    if (window.theme && window.theme.a11y) {
      window.theme.a11y.removeTrapFocus();
    }

    if (toggle) toggle.focus({ preventScroll: true });
  }

  function closeOtherQuickSizeMobileSheets(currentRoot) {
    document.querySelectorAll('quick-size-option.is-mobile-sheet-open').forEach((root) => {
      if (root !== currentRoot) closeQuickSizeMobileSheet(root);
    });
  }

  function openQuickSizeMobileSheet(root) {
    const sheetMount = getQuickSizeMobileSheetMount(root);
    const toggle = root.querySelector('.quick-size-option__toggle');
    const sheet = sheetMount?.querySelector('.quick-size-option__sheet');
    const closeBtn = sheetMount?.querySelector('.quick-size-option__sheet-close');
    if (!sheetMount || !sheet) return;

    preserveSliderScrollPosition(root);
    closeOtherQuickSizeMobileSheets(root);

    root._mobileSheetMount = sheetMount;
    portalQuickSizeMobileSheet(root, sheetMount);

    sheetMount.removeAttribute('hidden');
    sheetMount.removeAttribute('inert');
    sheetMount.setAttribute('aria-hidden', 'false');
    sheetMount.classList.add('is-open');
    root.classList.add('is-mobile-sheet-open');

    restoreSliderScrollPosition(root);

    const imgHolder = root.closest('[data-product-image]');
    if (imgHolder) imgHolder.classList.add('quick-size-sheet-active');

    const selectedEl = sheetMount.querySelector('[data-quick-size-selected]');
    const firstAvail = sheetMount.querySelector(
      '.quick-size-option__sheet-body .size-item:not(.size-item--disabled)'
    );
    if (selectedEl) {
      selectedEl.textContent = firstAvail ? firstAvail.getAttribute('data-value') || '' : '';
    }

    if (toggle) toggle.setAttribute('aria-expanded', 'true');

    document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true }));
    setTimeout(() => restoreSliderScrollPosition(root), 0);

    requestAnimationFrame(() => {
      restoreSliderScrollPosition(root);
      requestAnimationFrame(() => {
        restoreSliderScrollPosition(root);
        if (window.theme && window.theme.a11y && closeBtn) {
          window.theme.a11y.trapFocus(sheet, { elementToFocus: closeBtn });
        } else if (closeBtn) {
          closeBtn.focus({ preventScroll: true });
        }
        restoreSliderScrollPosition(root);
      });
    });
  }

  bindLoadMore();
  onFiltersOrSortUpdated();
  optionsEvent();
  enableMoreBtns();
  bindQuickSizeOptionDesktop();
  unlockScrollOnAcaModal();
  bindCollectionDescExpand();

  document.addEventListener('click', (e) => {
    const closer = e.target.closest('[data-quick-size-sheet-close]');
    if (!closer || !mobileQuickSizeSheetMq.matches) return;
    const sheetMount = closer.closest('[data-quick-size-mobile-sheet]');
    const root = getQuickSizeRootFromSheetMount(sheetMount) || closer.closest('quick-size-option');
    if (!root || !root.classList.contains('is-mobile-sheet-open')) return;
    e.preventDefault();
    closeQuickSizeMobileSheet(root);
  });

  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('.quick-size-option__toggle');
    if (!toggle) return;
    const el = toggle.closest('quick-size-option');
    if (!el) return;

    if (mobileQuickSizeSheetMq.matches) {
      e.preventDefault();
      e.stopPropagation();
      openQuickSizeMobileSheet(el);
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    el.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;

    if (mobileQuickSizeSheetMq.matches) {
      const openMobile = document.querySelector('quick-size-option.is-mobile-sheet-open');
      if (openMobile) {
        e.preventDefault();
        closeQuickSizeMobileSheet(openMobile);
      }
      return;
    }

    document.querySelectorAll('quick-size-option.is-open').forEach((open) => {
      open.classList.remove('is-open');
      const t = open.querySelector('.quick-size-option__toggle');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  });

  window.addEventListener('resize', () => {
    enableMoreBtns();
    if (desktopQuickSizeMq.matches) {
      document.querySelectorAll('quick-size-option.is-mobile-sheet-open').forEach((root) => {
        closeQuickSizeMobileSheet(root);
      });
    }
  });

  function bindQuickSizeOptionDesktop() {
    document.querySelectorAll('.product-item:not([data-quick-size-leave-bound])').forEach((card) => {
      card.setAttribute('data-quick-size-leave-bound', '');
      card.addEventListener('mouseleave', () => {
        if (!desktopQuickSizeMq.matches) return;
        const qso = card.querySelector('quick-size-option');
        if (!qso || !qso.classList.contains('is-open')) return;
        qso.classList.remove('is-open');
        const t = qso.querySelector('.quick-size-option__toggle');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function enableMoreBtns() {
    const mobileLimit = 5;

    if (window.innerWidth < 749) {
      productItems.forEach((pItem) => {
        pItem.querySelectorAll('.product-item__swatch-more').forEach((el) => el.remove());

        const total = parseInt(pItem.getAttribute('data-swatch-total'), 10) || 0;
        const remaining = total - mobileLimit;
        if (remaining > 0) {
          const span = document.createElement('span');
          span.className = 'product-item__swatch-more';
          span.textContent = `+${remaining}`;
          pItem.appendChild(span);
        }
      });

      siblingItems.forEach((pItem) => {
        pItem.querySelectorAll('.product-item__swatch-more').forEach((el) => el.remove());

        const items = pItem.querySelectorAll('tooltip-component');
        const remaining = items.length - mobileLimit;
        if (remaining > 0) {
          const span = document.createElement('span');
          span.className = 'product-item__swatch-more';
          span.textContent = `+${remaining}`;
          pItem.appendChild(span);
        }
      });
    } else {
      productItems.forEach((pItem) => {
        pItem.querySelectorAll('.product-item__swatch-more').forEach((el) => el.remove());
      });

      siblingItems.forEach((pItem) => {
        pItem.querySelectorAll('.product-item__swatch-more').forEach((el) => el.remove());
      });
    }
  }

  function bindLoadMore () {
    const button = document.getElementById('load-more');
    if (!button || button.dataset.bound === 'true') return;
    button.dataset.bound = 'true';
    if (button) {
      button.addEventListener('click', function handleClick() {
        const nextUrl = this.dataset.nextUrl;
        this.disabled = true;
        this.textContent = 'Loading...';
  
        fetch(nextUrl)
          .then(res => res.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newProducts = doc.querySelectorAll('#CollectionLoop > *');
            const newButton = doc.querySelector('#load-more');
            
            newProducts.forEach(product => {
              wrapper.querySelector('.grid').appendChild(product);
            });
  
            if (newButton) {
              this.replaceWith(newButton);
              bindLoadMore();
            } else {
              this.remove(); // No more pages
            }

            optionsEvent();
            bindQuickSizeOptionDesktop();
          })
          .catch(() => {
            this.textContent = 'Failed to load';
          });
      });
    }
  }

  function debounce(fn, delay = 150) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  const debouncedUpdate = debounce(() => {
    // Wait until is-loading is removed
    const checkInterval = setInterval(() => {
      if (!wrapper.classList.contains('is-loading')) {
        clearInterval(checkInterval);
        //onFiltersOrSortUpdated();
      }
    }, 100);
  }, 150);

  function onFiltersOrSortUpdated() {
    if (getCookie('filters') && JSON.parse(getCookie('filters'))) {
      const activeFilters = JSON.parse(getCookie('filters'));
      const filterAccordions = document.querySelectorAll('#Filter-accordion .filter-group details');
      activeFilters.forEach(filterValue => {
        filterAccordions.forEach(filter => {
          const label = filter.getAttribute('data-label');
          if (filterValue.label === label ) {
            if (filterValue.isOpen) {
              filter.setAttribute('open', true);
              filter.querySelector('.filter-group__body').style.height = 'auto';
            }
          }
        }); 
      });
    }
  }

  function getCookie(name) {
    const cookies = document.cookie.split('; ');
    for (let c of cookies) {
      const [key, val] = c.split('=');
      if (decodeURIComponent(key) === name) {
        return decodeURIComponent(val);
      }
    }
    return null;
  }

  function setCookie(name, value, days) {
    const expires = days
      ? `; expires=${new Date(Date.now() + days * 864e5).toUTCString()}`
      : '';
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value || '')}${expires}; path=/`;
  }

  if (wrapper) {
    const observer = new MutationObserver((mutations) => {
      const collectionLoopReplaced = mutations.some(m =>
        [...m.addedNodes].some(node =>
          node.nodeType === 1 && node.id === 'CollectionLoop'
        )
      );
      if (collectionLoopReplaced) {
        debouncedUpdate();
        bindLoadMore();
        optionsEvent();
      }
    });

    observer.observe(wrapper, {
      childList: true,
      subtree: true // watch for replacements inside
    });
  }

  function optionsEvent() {
    document.querySelectorAll('[js-option-btn]').forEach((btn) => {
      if (btn.dataset.quickSizeOptionBound === 'true') return;
      btn.dataset.quickSizeOptionBound = 'true';

      btn.addEventListener('click', (e) => {
        e.preventDefault();

        const mobileBody = btn.closest('.quick-size-option__sheet-body');
        const sheetMount = btn.closest('[data-quick-size-mobile-sheet]');
        const root = getQuickSizeRootFromSheetMount(sheetMount) || btn.closest('quick-size-option');

        if (mobileBody && root) {
          mobileBody.querySelectorAll('.size-item.is-selected').forEach((cell) => {
            cell.classList.remove('is-selected');
          });
          btn.classList.add('is-selected');
          const sel = sheetMount?.querySelector('[data-quick-size-selected]') || root.querySelector('[data-quick-size-selected]');
          if (sel) sel.textContent = btn.getAttribute('data-value') || '';
        }

        btn.classList.add('is-loading');
        const variantId = Number(btn.getAttribute('data-variant-id'));

        let obj = {
          quantity: 1,
          id: variantId
        };

        if (btn.classList.contains('is-monogram')) {
          obj = {
            quantity: 1,
            id: variantId,
            properties: {
              Monogram: ''
            }
          };
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [obj]
          })
        })
          .then((res) => res.json())
          .then(() => {
            document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
            btn.classList.remove('is-loading');
            if (mobileBody && root && root.classList.contains('is-mobile-sheet-open')) {
              closeQuickSizeMobileSheet(root);
            }
          })
          .catch(() => {
            btn.classList.remove('is-loading');
          });
      });
    });
  }

  function bindCollectionDescExpand() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.collection-desc-expand__toggle');
      if (!btn) return;
      const wrapper = btn.closest('[data-collection-desc-expand]');
      if (!wrapper || wrapper.classList.contains('is-expanded')) return;
      wrapper.classList.add('is-expanded');
      btn.setAttribute('aria-expanded', 'true');
      const preview = wrapper.querySelector('[data-collection-desc-preview]');
      const full = wrapper.querySelector('[data-collection-desc-full]');
      if (preview) preview.classList.add('hidden');
      if (full) {
        full.classList.remove('hidden');
        full.removeAttribute('hidden');
      }
    });
  }

function unlockScrollOnAcaModal() {
  if (!window.theme.isMobile()) return;
  const SELECTOR = '#aca-modal';
  const unlock = () =>
    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true, detail: 0 }));

  // If it's already on the page, unlock immediately
  if (document.querySelector(SELECTOR)) {
    unlock();
    return;
  }

  // Watch for it to be injected
  const mo = new MutationObserver(() => {
    const modal = document.querySelector(SELECTOR);
    if (modal) {
      unlock();
      mo.disconnect(); // fire once; remove if you want it to trigger every time
    }
  });

  mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
}

// Manage Loyalty Lion referral buttons by adding data-lion-refer attribute
// The SDK automatically handles clicks on elements with this attribute
function manageLoyaltyLionReferralButtons() {
  const buttons = document.querySelectorAll('a[href="#data-lion-refer-url"]');
  
  if (buttons.length === 0) {
    return false;
  }
  
  let fixed = false;
  buttons.forEach(button => {
    // Add the data-lion-refer attribute so the SDK can handle it
    if (!button.hasAttribute('data-lion-refer')) {
      button.setAttribute('data-lion-refer', '');
      button.href = '#'; // Change href to # so it doesn't navigate
      fixed = true;
    }
  });
  
  return fixed;
}

// Initialize Loyalty Lion referral button handlers
function initLoyaltyLionReferralButtons() {
  // First, try to fix buttons immediately
  manageLoyaltyLionReferralButtons();
  
  // Watch for buttons added dynamically
  const observer = new MutationObserver(() => {
    manageLoyaltyLionReferralButtons();
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Clean up observer after 30 seconds
  setTimeout(() => {
    observer.disconnect();
  }, 30000);
  
  // Also check periodically in case SDK loads after buttons are created
  let attempts = 0;
  const maxAttempts = 20; // 10 seconds
  
  const checkInterval = setInterval(() => {
    attempts++;
    manageLoyaltyLionReferralButtons();
    
    if (attempts >= maxAttempts) {
      clearInterval(checkInterval);
    }
  }, 500);
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLoyaltyLionReferralButtons);
} else {
  initLoyaltyLionReferralButtons();
}
})();